import FragmentRenderer from '../../renderers/FragmentRenderer';

export default class BrowserFragmentRenderer extends FragmentRenderer {
}
